import { cva, VariantProps } from 'class-variance-authority'

export type TabStyling = VariantProps<typeof tabStyling>

export const tabStyling = cva('text-body-sm text-neutral-fg font-normal text-center text-nowrap px-stack-roomy rounded-pill py-stack-tight', {
  variants: {
    variant: {
      pill: '',
      plain: '',
    },
    isActive: {
      true: '',
      false: '',
    },
    isDisabled: {
      true: 'cursor-not-allowed',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'pill',
      isActive: true,
      class: 'bg-fg text-fg-inverse shadow-card',
    },
    {
      variant: 'plain',
      isActive: true,
      class: 'bg-brand text-fg-inverse',
    },
    {
      variant: 'pill',
      isActive: false,
      class: 'bg-transparent hover:bg-surface hover:text-fg',
    },
    {
      variant: 'plain',
      isActive: false,
      class: 'hover:text-fg',
    },
  ],
  defaultVariants: {
    variant: 'pill',
    isActive: false,
  },
})
